import { isWasteOnly } from './config/deployment'
import { applyBranding, useAppStore } from './store/app'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { ConfirmDialogProvider } from './components/ui/ConfirmDialog'
import './styles/tokens.css'
import './styles/waste-branding.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
})

applyBranding(useAppStore.getState().branding)
if (isWasteOnly) {
  document.documentElement.classList.add('reclaps-theme')
  document.querySelector('meta[name="description"]')?.setAttribute('content', 'Waste collection management and operations.')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ConfirmDialogProvider>
          <App />
        </ConfirmDialogProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)
